import React from "react";

// Prevents a single component error from blanking the whole site.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI error boundary caught:", error, info);
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center px-6 bg-background" data-testid="error-boundary">
        <div className="max-w-md w-full text-center rounded-sm border border-border bg-card p-8 card-soft">
          <h1 className="font-heading text-2xl tracking-tight text-primary">Something went wrong</h1>
          <p className="mt-2 text-sm text-muted-foreground">This part of the site hit a temporary error. Please reload, or reach our team directly.</p>
          <div className="mt-6 flex flex-col gap-2">
            <button onClick={() => window.location.reload()} className="rounded-sm bg-orange-600 text-white hover:bg-orange-700 h-11 text-sm" data-testid="error-reload">Reload page</button>
            <a href="https://wa.me/85298548459" target="_blank" rel="noreferrer" className="rounded-sm bg-[#25D366] text-white h-11 grid place-items-center text-sm">WhatsApp us</a>
            <a href="/contact" className="rounded-sm border border-border bg-card hover:bg-secondary h-11 grid place-items-center text-sm text-foreground">Contact us</a>
          </div>
        </div>
      </div>
    );
  }
}
